import request from '@/utils/request'

export function getList (filters = {}, pagination = {}) {
  return request({
    url: '/protocol',
    method: 'get',
    headers: {
      'X-filters': JSON.stringify(filters),
      'X-pagination': JSON.stringify(pagination)
    }
  })
}

export function getDetail (id) {
  return request({
    url: '/protocol/' + id,
    method: 'get'
  })
}

export function upsert (data) {
  var method = 'post'
  var url = '/protocol'
  if (data.id) {
    method = 'put'
    url = '/protocol/' + data.id
  }
  return request({
    url,
    method,
    data
  })
}


export function remove (id) {
  return request({
    url: '/protocol/' + id,
    method: 'delete',
  })
}